import noMediaImageGhost1 from "../static/images/noMediaImageGhost1.png";
import noMediaImageGhost2 from "../static/images/noMediaImageGhost2.png";
import noMediaImageGhost3 from "../static/images/noMediaImageGhost3.png";
import noMediaImageGhost4 from "../static/images/noMediaImageGhost4.png";
import noMediaImageGhost5 from "../static/images/noMediaImageGhost5.png";
import noMediaImageGhost6 from "../static/images/noMediaImageGhost6.png";
import noMediaImageGhost7 from "../static/images/noMediaImageGhost7.png";
import noMediaImageGhost8 from "../static/images/noMediaImageGhost8.png";

import level1Badge from "../static/images/level1Badge.svg";
import level2Badge from "../static/images/level2Badge.svg";
import level3Badge from "../static/images/level3Badge.svg";

import position1Badge from "../static/images/position1Badge.svg";
import position2Badge from "../static/images/position2Badge.svg";
import position3Badge from "../static/images/position3Badge.svg";
import position4Badge from "../static/images/position4Badge.svg";

import WelcomeImage1 from "../components/svgs/WelcomeImage1";
import WelcomeImage2 from "../components/svgs/WelcomeImage2";
import WelcomeImage3 from "../components/svgs/WelcomeImage3";
import { MEDIA_ENDPOINT, MEDIA_ENDPOINT_RESIZED } from "./constants";

const DEFAULT_BADGES = {
  level1Badge: level1Badge,
  level2Badge: level2Badge,
  level3Badge: level3Badge,
  position1Badge: position1Badge,
  position2Badge: position2Badge,
  position3Badge: position3Badge,
  position4Badge: position4Badge,
};

const pickGhostImage = () => {
  const imageGhosts = [
    noMediaImageGhost1,
    noMediaImageGhost2,
    noMediaImageGhost3,
    noMediaImageGhost4,
    noMediaImageGhost5,
    noMediaImageGhost6,
    noMediaImageGhost7,
    noMediaImageGhost8,
  ];
  const randomIndex = Math.floor(Math.random() * imageGhosts.length);
  return imageGhosts[randomIndex];
};

export const pickWelcomeImage = (color1, color2, imageIndex) => {
  const welcomeImages = [
    <WelcomeImage1 color1={color1} color2={color2} />,
    <WelcomeImage2 color1={color1} color2={color2} />,
    <WelcomeImage3 color={color1} />,
  ];

  return welcomeImages[imageIndex];
};

export const getTouchPointImage = client => {
  let image;
  if (client && client.imageURL && client.imageURL[0]) {
    image = client.imageURL;
  }
  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  if (client && client.imageURL && client.imageURL[0]) {
    return `${MEDIA_ENDPOINT_RESIZED}medium/${image}`;
  } else {
    return null;
  }
};

export const fallBackImage = image => {
  return `${MEDIA_ENDPOINT}triggerResize/${image}`;
};

export const getTouchPointImageRegular = client => {
  let image;

  if (client && client.imageURL && client.imageURL[0]) {
    image = client.imageURL;
  }
  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  if (client && client.imageURL && client.imageURL[0]) {
    return `${MEDIA_ENDPOINT}triggerResize/${image}`;
  } else {
    return null;
  }
};

export const getImageFromUrl = image => {
  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  return `${MEDIA_ENDPOINT_RESIZED}small/${image}`;
};

export const _getImageFromUrl = image => {
  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  return `${MEDIA_ENDPOINT_RESIZED}large/${image}`;
};

export const getImageFromUrl_medium = image => {
  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  return `${MEDIA_ENDPOINT_RESIZED}medium/${image}`;
};

export const getImageDownloadUrl = image => {
  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  return `${MEDIA_ENDPOINT}triggerResize/${image}`;
};

export const getFallbackImageFromUrl = (image, customFallback) => {
  if (!image) {
    return customFallback || pickGhostImage();
  }
  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  return `${MEDIA_ENDPOINT}triggerResize/${image}`;
};

export const getTouchPointThumb = touchPoint => {
  let image;

  if (touchPoint && touchPoint.mediaURLs && touchPoint.mediaURLs[0]) {
    image = touchPoint.mediaURLs[0].image;
  }

  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  if (touchPoint && touchPoint.mediaURLs && touchPoint.mediaURLs[0]) {
    return `${MEDIA_ENDPOINT_RESIZED}medium/${image}`;
  } else {
    return null;
  }
};

export const getTouchPointThumbFallback = touchPoint => {
  let image;

  if (touchPoint && touchPoint.mediaURLs && touchPoint.mediaURLs[0]) {
    image = touchPoint.mediaURLs[0].image;
  }
  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  if (touchPoint && touchPoint.mediaURLs && touchPoint.mediaURLs[0]) {
    return `${MEDIA_ENDPOINT}triggerResize/${image}`;
  } else {
    return null;
  }
};

export const getImgExt = name => {
  const ext = name && name.substring(name.lastIndexOf(".") + 1, name.length);
  return ext || "jpg";
};

export const getDefaultBadge = (level, keyword) => {
  return DEFAULT_BADGES[`${keyword}${level}Badge`];
};

export const getBadgeImageFromUrl = (image, level, keyword) => {
  if (!image) {
    return getDefaultBadge(level, keyword);
  }
  const url = checkIfFullUrl(image);
  if (url) {
    return url;
  }
  return `${MEDIA_ENDPOINT}triggerResize/${image}`;
};

export const checkIfFullUrl = image => {
  if (image && (image.split(":")[0] === "https" || image.split(":")[0] === "http")) {
    if (image.startsWith("https://brandification.s3.eu-central-1.amazonaws.com/")) {
      const key = image.replace("https://brandification.s3.eu-central-1.amazonaws.com/", "");
      return `${MEDIA_ENDPOINT}${encodeURIComponent(key)}`;
    }
    return image;
  }
  return null;
};
